import { all, call, fork, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { ApiResponse } from 'api/ApiClient';
import * as AppActionTypes from 'store/App/types';
import { IAction, ISite, ISiteBalance } from 'types';
import * as API from '../../api';
import * as Actions from './actions';
import { Site } from './types';

interface ISitePayload {
  siteId?: string;
}

export function* getSite({ payload }: IAction<string, ISitePayload>) {
  try {
    if (payload.siteId) {
      // dispatch the request action to handle loading state
      yield put(Actions.getSiteRequest(payload.siteId));

      const response: ApiResponse<ISite> = yield call(API.Sites.show, payload.siteId);
      yield put(Actions.getSiteSuccess(response.body));
    } else {
      yield put(Actions.clearSite());
    }
  } catch (error: any) {
    yield put(Actions.getSiteError(error));
  }
}

export function* getSiteBalance({ payload }: IAction<Site, ISitePayload>) {
  try {
    const response: ApiResponse<ISiteBalance> = yield call(API.Sites.showSiteBalance, payload.siteId);
    yield put(Actions.getSiteBalanceSuccess(response.body));
  } catch (error: any) {
    yield put(Actions.getSiteBalanceError(error));
  }
}

export function* watchGetSite() {
  yield takeLatest(AppActionTypes.App.SET_CURRENT_EMPLOYEE_SUCCESS, getSite);
}

export function* watchGetSiteBalance() {
  yield takeEvery(Site.GET_SITE_BALANCE_REQUEST, getSiteBalance);
}

function* siteSaga() {
  yield all([fork(watchGetSite), fork(watchGetSiteBalance)]);
}
export { siteSaga };
